import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute, Params }   from '@angular/router';
import { SpinnerService } from '../shared/spinner/spinner.service';
import { SubscriptionService } from '../subscription/subscription.service';
import { Observable } from 'rxjs/Observable';
import { SubscriptionModel } from '../entity/subscription-model';

@Component({
  selector: 'subscription',
  templateUrl: './subscription.component.html'
})
export class SubscriptionComponent {

  private subscriptionModels: SubscriptionModel[];
  private selectedModel: SubscriptionModel;


  constructor(private route: ActivatedRoute, private spinnerService: SpinnerService, private subscriptionService: SubscriptionService) {
    this.subscriptionModels = new Array();
  }

  ngOnInit(): void {
    this.subscriptionModels = this.route.snapshot.data['subscriptionModels'];
  }

  private getSubscriptionModelByCode(code){
    this.spinnerService.start("Chargement");
    this.subscriptionService.getSubscriptionModelByCode(code).then(
      function(subscriptionModel: SubscriptionModel){
        this.selectedModel = subscriptionModel;
        this.spinnerService.stop();
      }.bind(this),
      function(){
        this.spinnerService.stop();
      }.bind(this)
    );
  }

  private setSelectedCategory(category): void {

  }
  
}


// WEBPACK FOOTER //
// ./src/app/subscription/subscription.component.ts